import { render, staticRenderFns } from "./TrainingCenterBanner.vue?vue&type=template&id=2e31b8f0&scoped=true&"
import script from "./TrainingCenterBanner.vue?vue&type=script&lang=js&"
export * from "./TrainingCenterBanner.vue?vue&type=script&lang=js&"
import style0 from "./TrainingCenterBanner.vue?vue&type=style&index=0&id=2e31b8f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e31b8f0",
  null
  
)

export default component.exports